import { lazy } from "react";
import LogsPage from "../features/log/pages/logs-page";

import UploadScoreCardPage from "../features/score-card/pages/upload-score-card-page";

import ScoreCardsHistoryPage from "../features/score-card/pages/score-cards-history-page";

import MonitoringQueueEntriesPage from "../features/monitoring-queue-entry/pages/monitoring-queue-entries-page";

import WatchListEntriesPage from "../features/watch-list-entry/pages/watch-list-entries-page";
import WatchListEntriesByWatchListPage from "../features/watch-list-entry/pages/watch-list-entries-by-watch-list-page";
import CreateWatchListEntryPage from "../features/watch-list-entry/pages/create-watch-list-entry-page";
import UpdateWatchListEntryPage from "../features/watch-list-entry/pages/update-watch-list-entry-page";
import UploadCustomWatchlistPage from "../features/watch-list-entry/pages/upload-custom-watchlist-page";

import ClientProfilePage from "../features/client-profile/pages/client-profile-page";
import OrganizationPage from "../features/organization/pages/settings/organization";

import ClientProfileDetailsPage from "../features/client-profile/pages/client-profile-details-page";

import WatchListEntriesHighRiskCountryPage from "../features/watch-list-entry-high-risk-country/pages/watch-list-entries-page";

import CreateWatchListEntryEuTerroristsPage from "../features/watch-list-entry-eu-terrorists/pages/create-watch-list-entry-page";
import UpdateWatchListEntryEuTerroristsPage from "../features/watch-list-entry-eu-terrorists/pages/update-watch-list-entry-page";

import WatchListUpdateReportPage from "../features/reports/pages/watch-list-update-report";
import MultipleClientsReportPage from "../features/reports/pages/multiple-clients-report";
import SingleClientReportPage from "../features/reports/pages/single-client-report-page";
import ScoringResultsReportPage from "../features/reports/pages/scoring-results-report-page";

import Home from "../features/home/home";
// import LoginPage from '../features/login/pages/LoginPage';
import LoginOidcPage from "../features/login/pages/LoginOidcPage";
import CallbackOidcPage from "../features/login/pages/CallbackOidcPage";
import LoginLayout from "../layouts/LoginLayout";
import SingleClientReportDetailsPage from "../features/reports/pages/single-client-report-details-page/SingleClientReportDetailsPage";
import AsyncJobsPage from "../features/organization/pages/async-jobs";
import EmailNotificationPage from "../features/organization/pages/email-notifications";
import LoginRulePage from "../features/login/pages/LoginRulePage";
import OrganizationLoginPage from "../features/organization/pages/settings";
import WatchListMultipleEntriesPage from "../features/watch-list-entry/pages/watch-list-entries-multiple-search-page/WatchListEntriesMultipleSearchPage";
import UploadSingleBatchUser from "../features/score-card/pages/upload-single-batch-user";

const isSmart = window.location.origin.includes("smartit");

const MainLayout = lazy(() => import("../layouts/MainLayout"));
// const MonitoringQueueEntriesPage = lazy(() =>
//   import(
//     "../features/monitoring-queue-entry/pages/monitoring-queue-entries-page"
//   )
// );
const routesConfig = {
  logsPage: {
    path: "/logs",
    component: LogsPage,
    layout: MainLayout,
    isProtected: true,
  },
  monitoringQueueEntriesPage: {
    path: "/monitoringqueueentries",
    component: MonitoringQueueEntriesPage,
    layout: MainLayout,
    isProtected: true,
  },
  profileDetails: {
    path: "/clientprofile",
    component: ClientProfilePage,
    layout: MainLayout,
    isProtected: true,
  },
  organizationDetail: {
    path: "/organizationDetail",
    component: OrganizationPage,
    layout: MainLayout,
    isProtected: true,
  },
  organizationLoginDetail: {
    path: "/organizationLoginDetail",
    component: OrganizationLoginPage,
    layout: MainLayout,
    isProtected: true,
  },
  massActionsDetails: {
    path: "/mass-actions",
    component: AsyncJobsPage,
    layout: MainLayout,
    isProtected: true,
  },
  exportJobsDetail: {
    path: "/export",
    component: AsyncJobsPage,
    layout: MainLayout,
    isProtected: true,
  },
  emailNotificationsDetail: {
    path: "/email-notifications",
    component: EmailNotificationPage,
    layout: MainLayout,
    isProtected: true,
  },
  // TODO: make all links to be in react way <Link>
  // TODO: change client profile details link
  clientProfileDetailsPage: {
    path: "/clientprofilee/details/:clientNumber/:categoryType/:clientName",
    component: ClientProfileDetailsPage,
    layout: MainLayout,
    isProtected: true,
  },
  scoreCardOperationsPage: {
    path: "/scorecard/operations",
    component: UploadScoreCardPage,
    layout: MainLayout,
    isProtected: true,
  },
  scoreCardHistoryPage: {
    path: "/scorecard/history",
    component: ScoreCardsHistoryPage,
    layout: MainLayout,
    isProtected: true,
  },
  uploadSingleBatchUser:{
    path: "/scorecard/upload-single-batch-user",
    component: UploadSingleBatchUser,
    layout: MainLayout,
    isProtected: true,
  },
  uploadCsvClientsPage: {
    path: "/scorecard/importclientscsv",
    component: UploadScoreCardPage,
    layout: MainLayout,
    isProtected: true,
  },
  watchListEntriesPage: {
    path: "/watchlistentries/search",
    component: WatchListEntriesPage,
    layout: MainLayout,
    isProtected: true,
  },
  watchListMultipleEntriesPage: {
    path: "/watchlistmultipleentries/search",
    component: WatchListMultipleEntriesPage,
    layout: MainLayout,
    isProtected: true,
  },
  watchListEntriesByWatchListPage: {
    path: "/watchlistentriesbywatchlist",
    component: WatchListEntriesByWatchListPage,
    layout: MainLayout,
    isProtected: true,
  },
  uploadCustomWatchlistPage: {
    path: "/uploadCustomWatchlist",
    component: UploadCustomWatchlistPage,
    layout: MainLayout,
    isProtected: true,
  },
  createWatchListEntryPage: {
    path: "/watchlistentries/create",
    component: CreateWatchListEntryPage,
    layout: MainLayout,
    isProtected: true,
  },
  updateWatchListEntryPage: {
    path: "/watchlistentries/update/:id",
    component: UpdateWatchListEntryPage,
    layout: MainLayout,
    isProtected: true,
  },
  watchListEntriesHighRiskCountryPage: {
    path: "/watchlistentrieshighriskcountry/search",
    component: WatchListEntriesHighRiskCountryPage,
    layout: MainLayout,
    isProtected: true,
  },
  createWatchListEntryEuTerroristsPage: {
    path: "/watchlistentryeuterrorists/create",
    component: CreateWatchListEntryEuTerroristsPage,
    layout: MainLayout,
    isProtected: true,
  },
  updateWatchListEntryEuTerroristsPage: {
    path: "/watchlistentryeuterrorists/update/:id",
    component: UpdateWatchListEntryEuTerroristsPage,
    layout: MainLayout,
    isProtected: true,
  },
  watchlistUpdateReport: {
    path: "/watchlistupdatereport",
    component: WatchListUpdateReportPage,
    layout: MainLayout,
    isProtected: true,
  },
  singleClientReport: {
    path: "/singleclientreport",
    component: SingleClientReportPage,
    layout: MainLayout,
    isProtected: true,
  },
  singleClientReportDetails: {
    path: "/singleclientreportdetails/:id",
    component: SingleClientReportDetailsPage,
    layout: MainLayout,
    isProtected: true,
  },
  multipleClientsReport: {
    path: "/multipleclientsreport",
    component: MultipleClientsReportPage,
    layout: MainLayout,
    isProtected: true,
  },
  scoringResultsReport: {
    path: "/scoringresultsreport",
    component: ScoringResultsReportPage,
    layout: MainLayout,
    isProtected: true,
  },
  loginPage: {
    path: "/login",
    component: isSmart ? LoginOidcPage : LoginRulePage,
    layout: LoginLayout,
    isProtected: false,
  },
  callbackPage: {
    path: "/callback",
    component: CallbackOidcPage,
    layout: LoginLayout,
    isProtected: false,
  },
  // exportSingleClientReportPdf: {
  //   path: '/exportSingleclientReportPdf/:id',
  //   component: ExportSingleClientReportPdfPage,
  //   layout: MainLayout,
  //   isProtected: false,
  // },
  homePage: {
    path: "/",
    component: Home,
    layout: MainLayout,
    isProtected: true,
  },
};

export default routesConfig;



// WEBPACK FOOTER //
// ./src/routes/routes-config.js